import React from "react";
import { useState, useRef, useEffect } from "react";
import { baseurladdress } from "../baseurl";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";

function Addintrashift() {
  const accessuserid = localStorage.getItem("id");
  const accesstoken = localStorage.getItem("token");
  const navigate = useNavigate();
  const Swal = require("sweetalert2");
  const [branch, setBranch] = useState([]);
  const [staffbranch, setStaffranch] = useState("");
  const [stbranchanme, setstbranchanme] = useState("");
  const [dept, setDept] = useState([]);
  const [Staffdept, setStaffdept] = useState("");
  const [deptnames, setDeptnames] = useState("");
  // const [deptcodes, setDeptcode] = useState("");
  const [staffname, setStaffname] = useState([]);
  const [staffids, setStaffids] = useState("");
  const [staffnames, setStaffnames] = useState("");
  const [staffcode, setStaffCode] = useState("");
  const [staff_typeid, setstaff_typeid] = useState("");
  const [staff_branchshift, setstaff_branchshift] = useState([]);
  const [stype, setstype] = useState("");
  const [stypename, setStypename] = useState("");
  const [AllStaffDetails, setAllStaffDetails] = useState([]);
  const [datefrom, setdatefrom] = useState("");

  const [minfrom, setminfrom] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  });

  const [dateTo, setDateto] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const toDateRef = useRef(null);

  const location = useLocation();
  const selval =
    location.state?.selectedOptions ||
    sessionStorage.getItem("selectedOptions");
  const searchVals =
    location.state?.searchVal || sessionStorage.getItem("searchVal");

  useEffect(() => {
    getbranch();
    getdept();
  }, []);

  // get all Branches
  const getbranch = () => {
    axios
      .get(baseurladdress + `getallbranchs`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        setBranch(data);
        // const user = data.map((item, index) => {
        //   return <option value={item.branch_id}> {item.branch_name} </option>;
        // });
        // setBranch(user);
      })
      .catch((error) => {
        alert(error);
      });
  };

  //get all department
  const getdept = () => {
    axios
      .get(baseurladdress + `getalldepts`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        // console.log(data);
        // const dept = data.map((item, index) => {
        //   return <option value={item.dept_id}> {item.dept_name} </option>;
        // });
        setDept(data);
      })
      .catch((error) => {
        alert(error);
      });
  };

  useEffect(() => {
    getshifttype();
  }, []);

  const getshifttype = (selectedShiftId) => {
    axios
      .get(baseurladdress + `getallshifttype`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        const options = data.map((item) => ({
          id: item.type_id,
          name: item.type_name,
        }));
        setstaff_branchshift(options);
        setstype(selectedShiftId);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const getStaffdetails = (data) => {
    if (staffbranch === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose a Branch",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
    } else {
      axios
        .get(
          `${baseurladdress}getAllStaffsperBranchandDept/${staffbranch}/${data}`,
          {
            headers: { Authorization: `Bearer ${accesstoken}` },
          }
        )
        // .then((res) => {
        //   const data = res.data.response;
        //   setAllStaffDetails(data);
        //   setstype("");
        //   const stffname = data.map((item) => (
        //     <option key={item.staff_id} value={item.staff_id}>
        //       {item.staff_name}
        //     </option>
        //   ));
        //   setStaffname(stffname);
        // })
        // .catch((error) => {
        //   alert(error);
        // });

        .then((res) => {
          const data = res.data.response;

          if (Array.isArray(data)) {
            setAllStaffDetails(data);
            setstype("");
            const stffname = data.map((item) => (
              <option key={item.staff_id} value={item.staff_id}>
                {item.staff_name}
              </option>
            ));
            setStaffname(stffname);
          } else {
            // Handle when response is not an array
            setAllStaffDetails([]);
            setStaffname([]);
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "warning",
              title: "No staff data found",
              text: "The selected branch/department has no staff.",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true,
            });
          }
        });
    }
  };

  useEffect(() => {
    if (stype && staff_branchshift.length > 0) {
      const selected = staff_branchshift.find((item) => item.id == stype);
      if (selected) {
        setStypename(selected.name);
      }
    }
  }, [stype, staff_branchshift]);

  const handleDateChange = (dates) => {
    axios
      .get(`${baseurladdress}getinterShiftDate/${dates}/${staffids}`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })

      .then((result) => {
        console.log("reslt:", result);
        const Data = result.data.status;
        if (Data == "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          setdatefrom("");
          Toast.fire({
            icon: "Error",
            title: "Shift Already assigned in that date",
          });
        } else {
          setdatefrom(dates);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  const handleBack = () => {
    const tab = location.state?.tab || "intra";
    navigate("/shiftassignment", {
      state: { tab, selval: selval, searchVal: searchVals },
    });
  };

  const handleAddIntrashiftAsgmnt = (e) => {
    e.preventDefault();
    if (stbranchanme == "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose Branch",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      document.getElementById("s_branches").focus();
    } else if (deptnames == "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose Department",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      document.getElementById("s_depts").focus();
    } 
     else if (staffnames == "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose Staff",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      document.getElementById("s_names").focus();
    } 
    else if (stypename == "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose Shift type",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      document.getElementById("s_types").focus();
    } 
    else if (datefrom == "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose From date",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      document.getElementById("s_froms").focus();
    } 
    else if (dateTo == "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose To date",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      toDateRef.current.focus();
    } else {
      var data = {
        staff_id: staffids,
        staff_name: staffnames,
        // staff_code: staffcode,
        dept_id: Staffdept,
        dept_name: deptnames,
        // dept_code: deptcodes,
        branch_id: staffbranch,
        branch_name: stbranchanme,
        shifttype_id: stype,
        shifttype_name: stypename,
        shiftmode: 2,
        shift_from: datefrom,
        shift_to: dateTo,
        crtd_by: accessuserid,
      };
      axios
        .post(baseurladdress + `addIntrashiftAssign`, data, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        .then((result) => {
          console.log("reslt:", result);
          const Data = result.data.status;
          if (Data == "success") {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "success",
              title: "Shift Data added successfully",
            });
            handleBack();
          } else {
            alert("Failed");
          }
        })
        .catch((error) => {
          alert(error);
        });
    }
  };

  return (
    <div>
      <Topnavbar />
      <Sidennav />
      <div
        class="content-wrap"
        style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
      >
        <div className="container-fluid">
          <div style={{ display: "flex" }}>
            <button
              onClick={handleBack}
              className="float active-link"
              style={{ border: "none", background: " rgb(63, 41, 184)" }}
            >
              <i className="fa fa-arrow-left my-float"></i>
            </button>
          </div>
          <form>
            <div className="row">
              <div class="col-xl-12 col-xxl-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">ADD INTRA SHIFT ASSIGNMENT</h4>
                  </div>
                  <div class="card-body">
                    <div class="basic-form mt-3">
                      <div class="form-row">
                        <div class="col-sm-4 mt-2 mt-sm-0">
                          <h6>
                            <span style={{ color: "red" }}>*</span> Branch
                          </h6>
                          <select
                            className="form-control select" id="s_branches"
                            name="branch"
                            onChange={(e) => {
                              const selbranchName =
                                e.target.options[e.target.selectedIndex].text;
                              setstbranchanme(selbranchName);
                              setStaffranch(e.target.value);
                            }}
                            required
                          >
                            {/* <option value="" disabled selected>
                              Select Branch
                            </option>
                            {branch} */}
                            <option value="">Select Branch</option>
                            {branch.map((b) => (
                              <option key={b.branch_id} value={b.branch_id}>
                                {b.branch_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>
                            <span style={{ color: "red" }}>*</span> Department
                          </h6>
                          <select
                            className="form-control select" id="s_depts"
                            name="Department"
                            onChange={(e) => {
                              setStaffdept(e.target.value);
                              getStaffdetails(e.target.value);
                              const depidsss = parseInt(e.target.value);
                              const seldepname =
                                e.target.options[e.target.selectedIndex].text;
                              setDeptnames(seldepname);
                              // const selectedStaffcode = dept.find(
                              //   (depts) => depts.dept_id === depidsss
                              // );
                              // if (selectedStaffcode) {
                              //   setDeptcode(selectedStaffcode.dept_code);
                              // }
                            }}
                            required
                          >
                            <option value="" disabled selected>
                              Select
                            </option>
                            {dept.map((item) => (
                              <option key={item.dept_id} value={item.dept_id}>
                                {item.dept_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-sm-3 mt-2 mt-sm-0">
                          <h6>
                            <span style={{ color: "red" }}>*</span> Staff Name
                          </h6>
                          <select
                            className="form-control select" id="s_names"
                            name="staffname"
                            onChange={(e) => {
                              const selectedId = parseInt(e.target.value);
                              const selectedName =
                                e.target.options[e.target.selectedIndex].text;
                              setStaffids(selectedId);
                              setStaffnames(selectedName);
                              const selectedStaff = AllStaffDetails.find(
                                (staff) => staff.staff_id === selectedId
                              );
                              if (selectedStaff) {
                                // getshifttype(selectedStaff.staff_branchshift);
                                setStaffCode(selectedStaff.staff_code);
                              }
                            }}
                            required
                          >
                            <option value="" disabled selected>
                              Select Staff Name
                            </option>
                            {staffname}
                          </select>
                        </div>
                        <div className="col-sm-2 mt-2 mt-sm-0">
                          <h6>Staff Code</h6>
                          <input
                            type="text"
                            class="form-control"
                            value={staffcode}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-4 mt-2 mt-sm-0">
                          <h6>Shift Type</h6>
                          <select
                            className="form-control select" id="s_types"
                            name="Shifttype"
                            value={stype}
                            onChange={(e) => {
                              setstype(e.target.value);
                              const setStypenames =
                                e.target.options[e.target.selectedIndex].text;
                              setStypename(setStypenames);
                            }}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {staff_branchshift.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-sm-2 mt-2 mt-sm-0">
                          <h6>From Date</h6>
                          <input
                            type="date" id="s_froms"
                            className="form-control"
                            required
                            value={datefrom}
                            onChange={(e) => {
                              handleDateChange(e.target.value);
                            }}
                            min={minfrom}
                          />
                        </div>
                        <div class="col-sm-2 mt-2 mt-sm-0">
                          <h6>To Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            required
                            onChange={(e) => setDateto(e.target.value)}
                            min={datefrom}
                            ref={toDateRef}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 offset-6 mt-4">
                    <button
                      type="button"
                      class="btn btn-primary mb-2"
                      onClick={handleAddIntrashiftAsgmnt}
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Addintrashift;
